<template lang="pug">
  #profile-updated
    .container
      .row
        p.text-center.grey
          strong(v-html="$LANG.profile.THANK_YOU")
        br
        br
        br
        .button-container
          .item
            router-link(:to="`/${$LOCALE}/`" gtm-label="profile-updated.home")
              img.buttons(:src="getImgUrl('btn-home')" gtm-label="profile-updated.home")
          .item
            a(@click="logout" gtm-label="profile-updated.logout")
              img.buttons(:src="getImgUrl('btn-logout')" gtm-label="profile-updated.logout")
</template>

<style lang="sass" scoped>
  @import "../sass/variables"

  #profile-updated
    .row
      margin-top: 70px

    .grey
      color: #666666

    .text-center
      text-align: center

    .button-container
      text-align: center
      display: flex
      justify-content: center
      img, a
        +desktop
          height: 40px

    .item
      cursor: pointer
      z-index: 9999
      img
        +mobile
          width: 100%
</style>

<script>
  import api from '../library/api.js'

  export default {
    created () {
      if (!window.localStorage.getItem('token')) {
        this.$router.push('/')
      }
    },

    methods: {
      getImgUrl (pic) {
        return require('../assets/images/' + pic + '-' + this.$LOCALE + '.png')
      },

      logout () {
        api(`logout?token=${window.localStorage.getItem('token')}`)
        window.localStorage.removeItem('token')
        this.$router.push('/')
      }
    }
  }
</script>
